var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDocumentLibrary = function SvgDocumentLibrary(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_95_2825",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 26,
    height: 26
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_95_2825)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.12077 17.8755H14.6208V16.7922H8.12077V17.8755ZM8.12077 13.5422H17.8708V12.4589H8.12077V13.5422ZM8.12077 9.20886H17.8708V8.12553H8.12077V9.20886ZM6.07923 21.6672C5.58053 21.6672 5.16417 21.5002 4.83014 21.1662C4.49612 20.8321 4.3291 20.4158 4.3291 19.9171V6.08399C4.3291 5.58529 4.49612 5.16893 4.83014 4.8349C5.16417 4.50088 5.58053 4.33386 6.07923 4.33386H19.9123C20.411 4.33386 20.8274 4.50088 21.1614 4.8349C21.4954 5.16893 21.6624 5.58529 21.6624 6.08399V19.9171C21.6624 20.4158 21.4954 20.8321 21.1614 21.1662C20.8274 21.5002 20.411 21.6672 19.9123 21.6672H6.07923ZM6.07923 20.5839H19.9123C20.0792 20.5839 20.232 20.5144 20.3708 20.3756C20.5097 20.2368 20.5791 20.0839 20.5791 19.9171V6.08399C20.5791 5.91715 20.5097 5.76431 20.3708 5.62547C20.232 5.48662 20.0792 5.4172 19.9123 5.4172H6.07923C5.91239 5.4172 5.75955 5.48662 5.62071 5.62547C5.48186 5.76431 5.41244 5.91715 5.41244 6.08399V19.9171C5.41244 20.0839 5.48186 20.2368 5.62071 20.3756C5.75955 20.5144 5.91239 20.5839 6.07923 20.5839Z",
    fill: "#707E9B"
  }))));
};
export default SvgDocumentLibrary;